import { IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { intl } from "../../../../intl";

import AvatarView from "../../../Common/AvatarView";
import GuardianCall from "../icons/GuardianCall";
import GuardianCallDecline from "../icons/GuardianCallDecline";

import OutgoingIncomingBackground from "../icons/OutgoingIncomingBackground.png";
const useStyles = makeStyles((theme) => ({
  root: {
    width: 360,
    height: 440,
    display: "flex",
    justifyContent: "space-around",
    flexDirection: "column",
    background: `url(${OutgoingIncomingBackground})`,
  },
  info: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    width: 120,
    height: 120,
    background: "#F5F7FB 0% 0% no-repeat padding-box",
    border: "1px solid #EAECF0",
    borderRadius: 48,
    marginTop: 20,
  },
  name: {
    fontSize: 17,
    color: "#000000",
    padding: 0,
    margin: 0,
    marginTop: 10,
  },
  callInfo: {
    fontSize: 15,
    color: "#8790A6",
    padding: 0,
    margin: 0,
  },
  containerDiv: {
    display: "flex",
    justifyContent: "center",
  },
  decline: {
    margin: 10,
    width: 64,
    height: 64,
    borderRadius: 28,
    background: "#E33B4A",
    "&:hover": {
      background: "#E33B4A",
    },
    "& svg": {
      fill: "white",
      width: 32,
      height: 32,
    },
  },
  answer: {
    margin: 10,
    width: 64,
    height: 64,
    borderRadius: 28,
    background: "#1AB461",
    "&:hover": {
      background: "#1AB461",
    },
    "& svg": {
      fill: "white",
      width: 32,
      height: 32,
    },
  },
}));

const InComingOutGoingCall = ({ data, type, onReject, onAnswer, onEnd }) => {
  const classes = useStyles();
  const me = useSelector((state) => state.user.me);

  let fromTitle = data?.fromTitle;
  if (data.payload) data = data.payload;

  const callInfo = `
        ${intl.formatMessage({
          id: `messaging.${type}`,
          defaultMessage: type,
        })} ${
    data.video && data.group?.type === "individual"
      ? intl.formatMessage({
          id: "messaging.videoCall",
          defaultMessage: "video call",
        })
      : [
          data.video && data.group?.type !== "individual"
            ? intl.formatMessage({
                id: "messaging.videoGroupCall",
                defaultMessage: "video group call",
              })
            : [
                !data.video && data.group?.type === "individual"
                  ? intl.formatMessage({
                      id: "messaging.audioCall",
                      defaultMessage: "audio call",
                    })
                  : intl.formatMessage({
                      id: "messaging.audioGroupCall",
                      defaultMessage: "audio group call",
                    }),
              ],
        ]
  }`;

  return (
    <div className={classes.root}>
      <div className={classes.info}>
        <AvatarView
          className={classes.avatar}
          displayName={
            data.group?.type === "individual"
              ? data.group.participants.filter((item) => item.id !== me.id)[0]
                  .firstName +
                " " +
                data.group.participants.filter((item) => item.id !== me.id)[0]
                  .lastName
              : data?.group?.name
          }
          typeGroup={data.group?.type !== "individual"}
          id={
            data.group?.type === "individual"
              ? data.group.participants.filter((item) => item.id !== me.id)[0]
                  .id
              : data?.group?.id
          }
        />
        <p className={classes.name}>
          {data.group?.type === "individual"
            ? data.group.participants.filter((item) => item.id !== me.id)[0]
                .firstName +
              " " +
              data.group.participants.filter((item) => item.id !== me.id)[0]
                .lastName
            : data?.group?.name}
          {type === "inComing" &&
            fromTitle &&
            data.group?.type !== "individual" &&
            " - " + fromTitle}
        </p>
        <p className={classes.callInfo}>{callInfo}...</p>
      </div>
      <div className={classes.containerDiv}>
        <IconButton
          onClick={
            type === "inComing" ? onReject : type === "outGoing" ? onEnd : null
          }
          disableRipple
          className={classes.decline}
        >
          <GuardianCallDecline />
        </IconButton>
        {type === "inComing" && (
          <IconButton
            onClick={onAnswer}
            disableRipple
            className={classes.answer}
          >
            <GuardianCall />
          </IconButton>
        )}
      </div>
    </div>
  );
};

export default InComingOutGoingCall;
